import UTILS from 'xe-utils'

// 封装函数 - 高精度计算, 如果表达式错误的话返回0
export function calculate(expression) {
  // 定义运算符和它们对应的函数
  const operators = {
    '+': UTILS.add,
    '-': UTILS.subtract,
    '*': UTILS.multiply,
    '/': UTILS.divide,
    '&': UTILS.round // 保留小数, 四舍五入
  }

  // 对后缀表达式进行求值
  function evaluate(tokens) {
    const stack = []

    while (tokens.length > 0) {
      const token = tokens.shift()

      // 如果是运算符，则从栈中取出两个数进行计算，结果再放回栈中
      if (token in operators) {
        const b = stack.pop()
        const a = stack.pop()
        stack.push(operators[token](a, b))
      } else {
        // 如果是数字，则直接放入栈中
        stack.push(parseFloat(token))
      }
    }

    // 栈中剩下的最后一个元素就是表达式的结果
    return stack.pop()
  }

  // 将表达式解析为标记列表
  function parse(expression) {
    let tokens = []
    let number = ''

    for (let i = 0; i < expression.length; i++) {
      const char = expression[i]

      // 如果是运算符或括号，则将前面的数字和当前的字符都加入到标记列表中
      if (char in operators || char === '(' || char === ')') {
        if (number !== '') {
          tokens.push(number)
          number = ''
        }

        tokens.push(char)
      } else {
        // 如果是数字，则添加到当前的数字字符串中
        number += char
      }
    }

    // 如果最后还剩下一个数字，则也加入到标记列表中
    if (number !== '') {
      tokens.push(number)
    }

    return tokens
  }

  // 将中缀表达式转换为后缀表达式
  function infixToPostfix(tokens) {
    const outputQueue = []
    const operatorStack = []
    // 定义运算符的优先级
    const precedence = {
      '+': 1,
      '-': 1,
      '*': 2,
      '/': 2,
      '&': 3
    }

    while (tokens.length > 0) {
      const token = tokens.shift()

      if (token in operators) {
        // 如果栈顶的运算符优先级大于等于当前运算符，则将栈顶的运算符放入到输出队列中
        while (operatorStack.length > 0 && precedence[operatorStack[operatorStack.length - 1]] >= precedence[token]) {
          outputQueue.push(operatorStack.pop())
        }

        // 将当前运算符放入到栈中
        operatorStack.push(token)
      } else if (token === '(') {
        // 如果是左括号，则直接放入到栈中
        operatorStack.push(token)
      } else if (token === ')') {
        // 如果是右括号，则将栈顶的运算符放入到输出队列中，直到遇到左括号
        while (operatorStack.length > 0 && operatorStack[operatorStack.length - 1] !== '(') {
          outputQueue.push(operatorStack.pop())
        }

        // 弹出左括号
        operatorStack.pop()
      } else {
        // 如果是数字，则直接放入到输出队列中
        outputQueue.push(token)
      }
    }

    // 如果栈中还剩下运算符，则依次放入到输出队列中
    while (operatorStack.length > 0) {
      outputQueue.push(operatorStack.pop())
    }

    return outputQueue
  }

  try {
    // 去除空格并解析为标记列表
    const tokens = parse(expression.replace(/\s+/g, ''))
    // 将标记列表转换为后缀表达式
    const postfixTokens = infixToPostfix(tokens)
    // 对后缀表达式进行求值
    const result = evaluate(postfixTokens)
    // 如果结果是 NaN，则返回 0
    return isNaN(result) ? 0 : result
  } catch (error) {
    // 捕获并处理可能出现的错误
    console.error('Invalid expression:', expression)
    return 0
  }
}
